//TODO implémenter googlemaps api pour adresse
function Input({type, value, id, required, setValue, error, validate, updateObject}) {
    function handleChange(event) {
        if (typeof setValue === 'function') {
            setValue(event.target.value);
        }
        validate(event.target.value);

        if (typeof updateObject === "function") {
            updateObject(id, event.target.value);
        }
    }

    function handleNewRow(event) {
        if (event.code === "Enter") {
            document.getElementById(id).rows = document.getElementById(id).rows + 1;
        }
    }

    if (type === "textarea"){
        return (
            <textarea onKeyDown={handleNewRow}
                      name={id} id={id} rows="1" required={required} onChange={handleChange} onBlur={handleChange}
                      className={"block pb-2.5 pt-4 w-full text-sm text-primary bg-transparent border-b-2 " +
                          (error ? "border-red-500" : "border-gray-300") +
                          " appearance-none focus:outline-none focus:ring-0 " +
                          "focus:border-primary-light peer"}
                      placeholder=" " value={value}
            ></textarea>
        );
    }

    return (
        <input type={type === "phone" ? "text" : type} name={id} id={id} value={value} onChange={handleChange} onBlur={handleChange}
               className={"block py-2.5 px-0 w-full text-sm text-primary bg-transparent border-0 border-b-2 " +
                   (error ? "border-red-500" : "border-gray-300") +
                   " appearance-none focus:outline-none focus:ring-0 focus:border-primary-light peer"}
               placeholder=" " required={required}/>
    );
}

export default Input;